import { z } from "@hono/zod-openapi";
import { EventItemSchema } from "../generated/zod/schemas/models";

/**
 * Base consent form schema derived from the API's EventItem schema.
 * This ensures field names and basic validations (like lengths) are in sync.
 */
export const consentFormSchema = EventItemSchema.pick({
  firstName: true,
  lastName: true,
  consentFormParticipantDateOfBirth: true,
  consentFormParticipantPronouns: true,
  consentFormParticipantAddress: true,
  
  // Parent/Carer
  consentFormParentCarerFirstName: true,
  consentFormParentCarerSurname: true,
  consentFormParentCarerAddress: true,
  consentFormParentCarerRelationship: true,
  consentFormParentCarerContactNumber: true,
  
  // Emergency Contacts
  consentFormEmergencyContact1Name: true,
  consentFormEmergencyContact1Relationship: true,
  consentFormEmergencyContact1Phone: true,
  consentFormEmergencyContact2Name: true,
  consentFormEmergencyContact2Relationship: true,
  consentFormEmergencyContact2Phone: true,
  
  // Medical
  consentFormImportantMedicalInformation: true,
  consentFormMedicationDetails: true,
  consentFormInjuriesDetails: true,
  consentFormDietaryRequirementsDetails: true,
  consentFormDisabilityDetails: true,
  
  // Consents
  dataProcessingConsent: true,
  consentFormCodeOfConductAccepted: true,
  emergencyTreatmentConsent: true,
  photoConsent: true,
  marketingConsent: true,
});

export type ConsentFormValues = z.infer<typeof consentFormSchema>;
